import { Component, OnInit, Output, EventEmitter, Input, ViewChild, TemplateRef, OnDestroy } from '@angular/core';
import { NbDialogService } from '@nebular/theme';
import { HttpClient } from '@angular/common/http';
import { CookieService } from 'ngx-cookie-service';
import * as _ from 'lodash';
import { TranslationService } from '../../language/translation.service';

@Component({
  selector: 'app-edit-announcement',
  templateUrl: './edit-announcement.component.html',
  styleUrls: ['./edit-announcement.component.scss']
})
export class EditAnnouncementComponent implements OnInit, OnDestroy {
  @Output() emitClose = new EventEmitter();
  @Output() emitList = new EventEmitter();
  @Input() orgData: Array<any>;
  @Input() info: {
    IsLoding: boolean,
    moType: number,
  };

  @Input() ProductList: Array<any>;

  modalRef = null;
  PdModalRef = null;
  languageChangeSub: any;

  @ViewChild('Modal') Modal: TemplateRef<any>;
  @ViewChild('PdModal') PdModal: TemplateRef<any>;

  mainDataList: Array<any>;
  showList: Array<any>;
  query = {
    searchKey: '',
    ORG_Company_ID: null,
  };
  status: {
    isSelectAll: boolean,
    showType: number,
  };
  isChecked = false;
  announcement = null;
  isSelectAll = false;

  constructor(
    private dialogService: NbDialogService,
    private http: HttpClient,
    private cookieService: CookieService,
    private translationService: TranslationService,
  ) {
    this.query.ORG_Company_ID = parseInt(this.cookieService.get('ORG_Company_ID'));
  }

  ngOnInit(): void {
    this.languageChangeSub = this.translationService.languageChanged$.subscribe(() => {});
  }

  ngOnDestroy(): void {
    if (this.languageChangeSub) {
      this.languageChangeSub.unsubscribe();
    }
  }

  ngAfterViewInit() {
    this.onOpen(this.orgData);
  }

  onOpen(dataList) {
    if (this.info.moType == 1) {
      this.mainDataList = _.cloneDeep(dataList.storeSelectList);
      this.mainDataList = this.mainDataList.map(item => {
        return { ...item, isChecked: false };
      });
    }

    this.modalRef = this.dialogService.open(this.Modal, {});
    this.modalRef.onClose.subscribe(() => {
      this.emitClose.emit(true);
    });
  }

  onSave() {
    const selectedIds = this.mainDataList
      .filter(item => item.isChecked)
      .map(item => item.value)
      .join(',');

    this.emitList.emit({
      announcement: this.announcement,
      selectedIds,
    });
    this.modalRef.close();
  }

  toggleSelectAll() {
    this.mainDataList = this.mainDataList.map(item => {
      return { ...item, isChecked: this.isSelectAll };
    });
  }

  onStoreToggle() {
    this.isSelectAll = this.mainDataList.every(item => item.isChecked);
  }

  t(key: string, fallback: string): string {
    const text = this.translationService.getText(key);
    return !text || text === key ? fallback : text;
  }
}
